import React from 'react';
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Button, Checkbox, Modal} from "semantic-ui-react";
import BillingOrganizationsListRow from "./BillingOrganizationsListRow";
import AddEditBillingOrgForm from "./AddEditBillingOrgForm";
import {connect} from "react-redux";
import {
    billingOrganizationsTableSearch,
    toggleAddBillingOrgModal,
    toggleBillingOrgSort,
    validateBillingOrg
} from "../actions/BillingOrganizationsActions";
import {BillingOrgSortFields} from "../constants/BillingOrganizationsActionConstants";
import {TableSearch} from "../../../common/components/TableSearch";

export class BillingOrganizationsTable extends React.Component {

    static propTypes = {
        BillingOrganizationsData: PropTypes.array,
    }

    handleBillingOrgSort = (sortKey) => {
        this.props.changeBillingOrgSort(sortKey);
    }

    handleAddBillingOrgClick = () => {
        this.props.toggleBillingOrgModal();
    }

    handleAddBillingOrgFormSubmit = () => {
        this.props.validateOrgForm(this.props.billingOrgObject);
    }

    handleOrgTableSearch = (e) => {
        this.props.typeAheadSearchOrg(e.target.value)
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox disabled/>
            </Table.Header>,
            <Table.Header key="organization-name" sortKey={BillingOrgSortFields.NAME}>Organization Name</Table.Header>,
            <Table.Header key="billing-a-number"> Billing A Number </Table.Header>,
            <Table.Header key="location-a-number"> Location A Number </Table.Header>,
            <Table.Header key="monthly-minimum-commitment"> Min. Monthly Commitment </Table.Header>,
            <Table.Header key="monthly-platform-fee"> Monthly Platform Fee </Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.BillingOrganizationsData.map((org, idx) => (
            <BillingOrganizationsListRow
                organizationObject={org}
                key={idx}
                orgID={org.id}
                organizationName={org.name}
                billingANumber={org.billing_a_number}
                locationANumber={org.location_a_number}
                monthlyMinCommit={org.monthly_minimum_commitment}
                monthlyPlatformFee={org.monthly_platform_fee}
            />
        ))
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Button
                        icon="file excel outline" size="big"
                        disabled={true}
                    />
                    {this.props.canEdit
                        ? (
                            <Button
                                style={{float: "right"}} color="blue"
                                icon="add"
                                content="Add a new Organization"
                                onClick={this.handleAddBillingOrgClick}
                            />
                        )
                        : null}
                </div>

                <div className="billing-list-container">
                    <TableSearch
                        handleSearch={this.handleOrgTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.billingOrgSortKey}
                            sortDirection={this.props.billingOrgSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handleBillingOrgSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.addOrgModalOpen}
                >
                    <Modal.Header>
                        {"Add a new Organization"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditBillingOrgForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleAddBillingOrgClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddBillingOrgFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    billingOrgSortKey: state.billing.organizations.billingOrgSortKey,
    billingOrgSortDirection: state.billing.organizations.billingOrgSortDirection,

    billingOrgObject: state.billing.addEditBillingOrg.billingOrgObject,
    orgIdForDelete: state.billing.addEditBillingOrg.orgIdForDelete,
    addOrgModalOpen: state.billing.addEditBillingOrg.addOrgModalOpen,
});

const mapDispatchToProps = dispatch => ({
    toggleBillingOrgModal: () => {dispatch(toggleAddBillingOrgModal())},
    validateOrgForm: (billingOrgObject) => {dispatch(validateBillingOrg(billingOrgObject))},
    changeBillingOrgSort: (sortKey) => {dispatch(toggleBillingOrgSort(sortKey))},
    typeAheadSearchOrg: (value) => {dispatch(billingOrganizationsTableSearch(value))}
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingOrganizationsTable)

